import axios from 'axios'

export const state = {
  cancelReasons: null,
}

export const getters = {
  cancelReasons: (state) => state.cancelReasons,
  cancelReasonOptions: (state) =>
    state.cancelReasons &&
    state.cancelReasons.map(({ title }) => ({ id: title, label: title })),
}

export const mutations = {
  SET_CANCEL_REASONS(state, cancelReasons) {
    state.cancelReasons = cancelReasons
  },
}

export const actions = {
  fetchAllCancelReasons({ commit, state, rootState }) {
    return axios.get('/api/cancel_reasons').then((response) => {
      const cancelReasons = response.data
      commit('SET_CANCEL_REASONS', cancelReasons)
      return cancelReasons
    })
  },
}
